import { useTranslation } from 'react-i18next';
import { pillarArticles } from '@/mocks/articles';

const badgeStyles: Record<string, string> = {
  guide: 'bg-primary-50 text-primary-600',
  review: 'bg-secondary-50 text-secondary-600',
  shipping: 'bg-accent-50 text-accent-600',
  products: 'bg-primary-50 text-primary-600',
  sellers: 'bg-secondary-50 text-secondary-600',
  qc: 'bg-accent-50 text-accent-600',
  warehouse: 'bg-secondary-50 text-secondary-600',
  coupon: 'bg-accent-50 text-accent-600',
  legit: 'bg-primary-50 text-primary-600',
  safety: 'bg-secondary-50 text-secondary-600',
  buying: 'bg-primary-50 text-primary-600',
  fees: 'bg-accent-50 text-accent-600',
  alternatives: 'bg-secondary-50 text-secondary-600',
};

const categoryLabels: Record<string, string> = {
  guide: 'Guide',
  review: 'Review',
  shipping: 'Shipping',
  products: 'Products',
  sellers: 'Sellers',
  qc: 'QC',
  warehouse: 'Warehouse',
  coupon: 'Coupon',
  legit: 'Legit',
  safety: 'Safety',
  buying: 'Buying',
  fees: 'Fees',
  alternatives: 'Alternatives',
};

export default function FeaturedArticles() {
  const { t, i18n } = useTranslation();

  const lang = i18n.language === 'pt-br' ? 'pt-br' : i18n.language === 'de' ? 'de' : 'en';

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-4">
            {t('articles_title')}
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">
            {t('articles_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {pillarArticles.map((article, index) => (
            <article
              key={article.slug}
              className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 hover:shadow-lg transition-all duration-300 animate-slide-up"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <a href={`/article/${article.slug}`} className="block h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title[lang]}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </a>
              <div className="p-6">
                <div className="flex items-center gap-2 text-xs text-foreground-500 mb-3">
                  <span className={`px-2 py-1 rounded-full font-medium ${badgeStyles[article.category] || 'bg-primary-50 text-primary-600'}`}>
                    {categoryLabels[article.category]}
                  </span>
                  <span>2026</span>
                </div>
                <a href={`/article/${article.slug}`}>
                  <h3 className="text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {article.title[lang]}
                  </h3>
                </a>
                <p className="text-sm text-foreground-600 mb-4 leading-relaxed line-clamp-3">
                  {article.desc[lang]}
                </p>
                <a
                  href={`/article/${article.slug}`}
                  className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors"
                >
                  {t('articles_read_more')}
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}